import "./App.css";
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import HowWeTransform from "./pages/HowWeTransform";
import AiOpportunities from "./pages/AiOpportunities";
import CognitiveAI from "./pages/CognitiveAI";
import About from "./pages/About";
import Insights from "./pages/Insights";
import SimpelLabs from "./pages/SimpelLabs";
import { AuraProvider } from "./components/aura/AuraProvider";
import AuraLauncher from "./components/aura/AuraLauncher";

import Discover from "./pages/Discover";
import SimpelLoop from "./pages/SimpelLoop";
import CaseStudies from "./pages/CaseStudies";
import SkipperCaseStudy from "./pages/SkipperCaseStudy";
// import ErpServices from "./pages/ErpServices";
// import IntegrationServices from "./pages/IntegrationServices";
// import WhatsappBotServices from "./pages/WhatsappBotServices";
import Career from "./pages/Career";
import AiEngineerRole from "./pages/AiEngineerRole";
import OpenPositions from "./pages/OpenPositions";
import FinancialServicesCaseStudy from "./pages/FinancialServicesCaseStudy";
import WhatWeDo from "./pages/WhatWeDo";
import ManufacturingStackPage from "./pages/ManufacturingStackPage";
import SalesStackPage from "./pages/SalesStackPage";
import AgenticAiPage from "./pages/AgenticAiPage";
import OurStoryModal from "./components/OurStoryModal";
import LegalPage from "./pages/LegalPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuraProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/what-we-do" element={<WhatWeDo />} />
            <Route path="/services/agentic-ai" element={<AgenticAiPage />} />
            <Route path="/what-we-do/services/agentic-ai" element={<AgenticAiPage />} />
            <Route path="/what-we-do/agentic-ai" element={<AgenticAiPage />} />
            <Route path="/agentic-ai" element={<AgenticAiPage />} />
            <Route path="/what-we-do/manufacturing-automation-stack" element={<ManufacturingStackPage />} />
            <Route path="/stack/manufacturing-automation" element={<ManufacturingStackPage />} />
            <Route path="/manufacturing-automation-stack" element={<ManufacturingStackPage />} />
            <Route path="/what-we-do/sales-automation-stack" element={<SalesStackPage />} />
            <Route path="/sales-automation-stack" element={<SalesStackPage />} />
            <Route path="/stack/sales-automation" element={<SalesStackPage />} />
            <Route path="/transform" element={<HowWeTransform />} />
            {/* <Route path="/services/erp" element={<ErpServices />} /> */}
            {/* <Route path="/services/integration" element={<IntegrationServices />} /> */}
            {/* <Route path="/services/whatsapp-bot" element={<WhatsappBotServices />} /> */}
            {/* <Route path="/whatsapp-bot" element={<WhatsappBotServices />} /> */}
            <Route path="/simpel-loop" element={<SimpelLoop />} />
            <Route path="/loop" element={<SimpelLoop />} />
            <Route path="/case-studies" element={<CaseStudies />} />
            <Route path="/case-studies/skipper-limited" element={<SkipperCaseStudy />} />
            <Route path="/case-studies/skipper" element={<SkipperCaseStudy />} />
            <Route path="/skipper-limited" element={<SkipperCaseStudy />} />
            <Route path="/ai-opportunities" element={<AiOpportunities />} />
            <Route path="/cognitive" element={<CognitiveAI />} />
            <Route path="/labs" element={<SimpelLabs />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/financial-services" element={<FinancialServicesCaseStudy />} />
            <Route path="/case-study/finance-services" element={<FinancialServicesCaseStudy />} />
            <Route path="/case-studies/financial-services" element={<FinancialServicesCaseStudy />} />
            <Route path="/about" element={<About />} />
            <Route path="/careers" element={<Career />} />
            <Route path="/career" element={<Career />} />
            <Route path="/careers/open-positions" element={<OpenPositions />} />
            <Route path="/careers/roles" element={<OpenPositions />} />
            <Route path="/open-positions" element={<OpenPositions />} />
            <Route path="/careers/:roleId" element={<AiEngineerRole />} />
            <Route path="/career/:roleId" element={<AiEngineerRole />} />
            <Route path="/careers/roles/:roleId" element={<AiEngineerRole />} />
            <Route path="/privacy-policy" element={<LegalPage initialTab="privacy-policy" />} />
            <Route path="/privacy" element={<LegalPage initialTab="privacy-policy" />} />
            <Route path="/terms-of-use" element={<LegalPage initialTab="terms-of-use" />} />
            <Route path="/terms" element={<LegalPage initialTab="terms-of-use" />} />
            <Route path="/cookie-policy" element={<LegalPage initialTab="cookie-policy" />} />
            <Route path="/cookies" element={<LegalPage initialTab="cookie-policy" />} />
            <Route path="/legal" element={<LegalPage initialTab="privacy-policy" />} />
            <Route path="/discover" element={<Discover />} />
          </Routes>
          <AuraLauncher />
          <OurStoryModal />
        </AuraProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
